import { useContent } from '@/hooks/useContent';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useContent('common');

  return (
    <footer className="bg-background-100 text-foreground-50 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                alt="FMO LLC Insulation Services"
                className="h-14 w-auto object-contain"
                src="https://static.readdy.ai/image/3ce9d24c92e6c33dbaca65a0380531ab/059954b6faaad54bb7acfcf00b0835ac.png"
              />
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed mt-4">
              {t('footer_company_desc')}
            </p>
            <div className="flex flex-col gap-2 mt-5 mb-5">
              <a href="tel:+15747219810" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">{t('footer_phone')}</a>
              <a href="mailto:miguelceo@fmoinsulation.com" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">{t('footer_email')}</a>
            </div>
            <iframe
              title="Service Area - Lafayette, Indiana"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d97647.5!2d-86.9081!3d40.4259!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88133a05d17b6db7%3A0x24df2e4e6f9e7d0!2sLafayette%2C%20IN!5e0!3m2!1ses!2sus!4v1699999999999!5m2!1ses!2sus"
              width="100%"
              height={140}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-lg mt-5"
            ></iframe>
          </div>

          <div>
            <h4 className="text-primary-500 font-semibold uppercase text-xs tracking-widest mb-5">{t('footer_navigation')}</h4>
            <ul className="flex flex-col gap-3">
              <li><Link to="/" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">{t('footer_nav_home')}</Link></li>
              <li><Link to="/services" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">{t('footer_nav_services')}</Link></li>
              <li><Link to="/about" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">{t('footer_nav_about')}</Link></li>
              <li><Link to="/contact" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">{t('footer_nav_contact')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-primary-500 font-semibold uppercase text-xs tracking-widest mb-5">{t('footer_our_services')}</h4>
            <ul className="flex flex-col gap-3">
              <li><Link to="/services" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">{t('footer_service_spray_foam')}</Link></li>
              <li><Link to="/services" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">{t('footer_service_batt')}</Link></li>
              <li><Link to="/services" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">{t('footer_service_cellulose')}</Link></li>
              <li><Link to="/services" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">{t('footer_service_attic')}</Link></li>
              <li><Link to="/services" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">{t('footer_service_walls')}</Link></li>
              <li><Link to="/services" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">{t('footer_service_crawl')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-primary-500 font-semibold uppercase text-xs tracking-widest mb-5">{t('footer_contact')}</h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-primary-500 w-5 h-5 flex items-center justify-center"></i>
                </div>
                <span className="text-foreground-400 text-sm leading-relaxed">
                  {t('footer_address_line1')}<br />
                  {t('footer_address_line2')}
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-primary-500 w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div className="flex flex-col gap-1">
                  <a href="tel:+15747219810" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer block">{t('footer_phone')}</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-primary-500 w-5 h-5 flex items-center justify-center"></i>
                </div>
                <a href="mailto:miguelceo@fmoinsulation.com" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer block">{t('footer_email')}</a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-time-line text-primary-500 w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-foreground-50 text-sm font-semibold">{t('footer_hours_title')}</span>
                  <span className="text-foreground-400 text-sm">{t('footer_hours_weekdays')}</span>
                  <span className="text-foreground-400 text-sm">{t('footer_hours_weekends')}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-400/50 text-xs font-medium">{t('footer_copyright')}</p>
          <div className="flex items-center gap-3">
            <p className="text-foreground-400/50 text-xs font-medium">{t('footer_serving')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}